import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/dashboard/dashboard.page').then(m => m.DashboardPage),
        title: 'Dashboard - CMS Admin',
      },
      {
        path: 'games',
        loadComponent: () =>
          import('./modules/games/pages/games-list/games-list.page').then(m => m.GamesListPage),
        title: 'Juegos - CMS Admin',
      },
      {
        path: 'games/:id/edit',
        loadComponent: () =>
          import('./modules/games/pages/game-edit/game-edit.page').then(m => m.GameEditPage),
        title: 'Editar Juego - CMS Admin',
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./modules/categories/pages/categories-list/categories-list.page').then(m => m.CategoriesListPage),
        title: 'Categorías - CMS Admin',
      },
      {
        path: 'covers',
        loadComponent: () =>
          import('./modules/covers/pages/covers-list/covers-list.page').then(m => m.CoversListPage),
        title: 'Portadas - CMS Admin',
      },
      {
        path: 'lobbys',
        loadComponent: () =>
          import('./modules/lobbys/pages/lobbys-list/lobbys-list.page').then(m => m.LobbysListPage),
        title: 'Lobbys - CMS Admin',
      },
      {
        path: 'segunda-chance',
        loadComponent: () =>
          import('./modules/segunda-chance/pages/segunda-chance-settings/segunda-chance-settings.page').then(
            m => m.SegundaChanceSettingsPage
          ),
        title: 'Segunda Chance - CMS Admin',
      },
      {
        path: 'loteria',
        loadComponent: () =>
          import('./modules/loteria/pages/loteria-settings/loteria-settings.page').then(m => m.LoteriaSettingsPage),
        title: 'Lotería - CMS Admin',
      },
      {
        path: 'promotional-popups',
        loadComponent: () =>
          import('./modules/promotional-popups/pages/promotional-popups-list/promotional-popups-list.page').then(
            m => m.PromotionalPopupsListPage
          ),
        title: 'Pop-up promocional - CMS Admin',
      },
      {
        path: 'eraspadita-responsible-popup',
        loadComponent: () =>
          import(
            './modules/eraspadita-responsible-popup/pages/eraspadita-responsible-popup/eraspadita-responsible-popup.page'
          ).then(m => m.EraspaditaResponsiblePopupPage),
        title: 'Popup Juego Responsable eRaspadita - CMS Admin',
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./modules/users/pages/users-list/users-list.page').then(m => m.UsersListPage),
        title: 'Usuarios - CMS Admin',
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./modules/settings/pages/settings/settings.page').then(m => m.SettingsPage),
        title: 'Configuración - CMS Admin',
      },
      {
        path: 'stats',
        loadComponent: () =>
          import('./modules/stats/pages/stats/stats.page').then(m => m.StatsPage),
        title: 'Estadísticas - CMS Admin',
      },
      {
        path: 'import',
        loadComponent: () =>
          import('./modules/import/pages/import/import.page').then(m => m.ImportPage),
        title: 'Importar - CMS Admin',
      },
      {
        path: 'news',
        loadComponent: () =>
          import('./modules/news/pages/news-list/news-list.page').then(m => m.NewsListPage),
        title: 'Noticias - CMS Admin',
      },
      {
        path: 'news/create',
        loadComponent: () =>
          import('./modules/news/pages/news-edit/news-edit.page').then(m => m.NewsEditPage),
        title: 'Crear Noticia - CMS Admin',
      },
      {
        path: 'news/:id/edit',
        loadComponent: () =>
          import('./modules/news/pages/news-edit/news-edit.page').then(m => m.NewsEditPage),
        title: 'Editar Noticia - CMS Admin',
      },
      {
        path: 'news-categories',
        loadComponent: () =>
          import('./modules/news-categories/pages/news-categories-list/news-categories-list.page').then(m => m.NewsCategoriesListPage),
        title: 'Categorías de Noticias - CMS Admin',
      },
      {
        path: 'informational-pages',
        loadComponent: () =>
          import('./modules/informational-pages/pages/informational-pages-list/informational-pages-list.page').then(m => m.InformationalPagesListPage),
        title: 'Páginas Informativas - CMS Admin',
      },
      {
        path: 'informational-pages/create',
        loadComponent: () =>
          import('./modules/informational-pages/pages/informational-page-edit/informational-page-edit.page').then(m => m.InformationalPageEditPage),
        title: 'Crear Página Informativa - CMS Admin',
      },
      {
        path: 'informational-pages/:id/edit',
        loadComponent: () =>
          import('./modules/informational-pages/pages/informational-page-edit/informational-page-edit.page').then(m => m.InformationalPageEditPage),
        title: 'Editar Página Informativa - CMS Admin',
      },
      {
        path: 'email-result-subscriptions',
        loadComponent: () =>
          import('./modules/email-result-subscriptions/pages/email-result-subscriptions-list/email-result-subscriptions-list.page').then(
            m => m.EmailResultSubscriptionsListPage
          ),
        title: 'Suscripciones email - CMS Admin',
      },
      {
        path: 'streaming-config',
        loadComponent: () =>
          import('./modules/streaming-config/pages/streaming-config/streaming-config.page').then(m => m.StreamingConfigPage),
        title: 'Configuración streaming - CMS Admin',
      },
      {
        path: 'config-environment',
        loadComponent: () =>
          import('./modules/config-environment/pages/config-environment/config-environment.page').then(
            m => m.ConfigEnvironmentPage
          ),
        title: 'Configuración de entorno - CMS Admin',
      },
      {
        path: 'raspaditas-fisicas',
        loadComponent: () =>
          import('./modules/raspaditas-fisicas/pages/raspaditas-fisicas-list/raspaditas-fisicas-list.page').then(
            m => m.RaspaditasFisicasListPage
          ),
        title: 'Raspaditas Físicas - CMS Admin',
      },
      {
        path: 'raspaditas-fisicas/new',
        loadComponent: () =>
          import('./modules/raspaditas-fisicas/pages/raspadita-fisica-edit/raspadita-fisica-edit.page').then(
            m => m.RaspaditaFisicaEditPage
          ),
        title: 'Nueva Raspadita Física - CMS Admin',
      },
      {
        path: 'raspaditas-fisicas/:id/edit',
        loadComponent: () =>
          import('./modules/raspaditas-fisicas/pages/raspadita-fisica-edit/raspadita-fisica-edit.page').then(
            m => m.RaspaditaFisicaEditPage
          ),
        title: 'Editar Raspadita Física - CMS Admin',
      },
      {
        path: 'e-raspaditas',
        loadComponent: () =>
          import('./modules/e-raspaditas/pages/e-raspaditas-list/e-raspaditas-list.page').then(
            m => m.ERaspaditasListPage
          ),
        title: 'Raspaditas Electrónicas - CMS Admin',
      },
      {
        path: 'bancas-vendedores',
        loadComponent: () =>
          import('./modules/bancas-vendedores/pages/bancas-vendedores-list/bancas-vendedores-list.page').then(
            m => m.BancasVendedoresListPage
          ),
        title: 'Bancas Vendedores - CMS Admin',
      },
      {
        path: 'bancas-vendedores/new',
        loadComponent: () =>
          import('./modules/bancas-vendedores/pages/banca-vendedor-edit/banca-vendedor-edit.page').then(
            m => m.BancaVendedorEditPage
          ),
        title: 'Nueva Banca - CMS Admin',
      },
      {
        path: 'bancas-vendedores/:id/edit',
        loadComponent: () =>
          import('./modules/bancas-vendedores/pages/banca-vendedor-edit/banca-vendedor-edit.page').then(
            m => m.BancaVendedorEditPage
          ),
        title: 'Editar Banca - CMS Admin',
      },
      {
        path: 'e-raspaditas/new',
        loadComponent: () =>
          import('./modules/e-raspaditas/pages/e-raspadita-edit/e-raspadita-edit.page').then(
            m => m.ERaspaditaEditPage
          ),
        title: 'Nueva eRaspadita - CMS Admin',
      },
      {
        path: 'e-raspaditas/:id/edit',
        loadComponent: () =>
          import('./modules/e-raspaditas/pages/e-raspadita-edit/e-raspadita-edit.page').then(
            m => m.ERaspaditaEditPage
          ),
        title: 'Editar eRaspadita - CMS Admin',
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.page').then(m => m.UnauthorizedPage),
    title: 'No Autorizado - CMS Admin',
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
    title: 'No Encontrado - CMS Admin',
  },
];
